import { ConfirmationModalOptions } from './../../models/modal.model';
import { fdSelectModelList } from './../../../models/fdSelect.model';
import { Options } from 'ng5-slider';
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { fdSelectModel } from 'src/app/models/fdSelect.model';
import * as $ from 'jquery';


@Component({
    selector: 'fd-select',
    templateUrl: './fd-select.component.html',
    styleUrls: ['./fd-select.scss']
})
export class FdSelectComponent implements OnChanges {

    public modalDeleteMessage: ConfirmationModalOptions;
    public showList: boolean;
    public noData: boolean;
    public filtroBusqueda: string;
    public elementList: fdSelectModelList[];
    @Input() fdSelectOptions: fdSelectModel;
    @Input() listaElementos: fdSelectModelList[];
    @Output() buscarInformacion = new EventEmitter();
    @Output() listaSeleccionados = new EventEmitter();

    private options: fdSelectModel;
    constructor() {

        if (!this.fdSelectOptions) {
            this.fdSelectOptions = new fdSelectModel('Ingrese El valor', 'BUSCAR', null, null);
        }

        // fromero:
        // en el constructor se debe crear el objeto de opciones del modal que se estan inyectando en el html,
        // cuando son formularios
        this.modalDeleteMessage = new
            ConfirmationModalOptions('Confirmación'
                , '¿Está Seguro de agregar del grupo?'
                , 'Si', 'No'
                , 'fas fa-clone'
                , true
                , false
                , 'Ingresar al grupo', false
                , 'btn-primary float-xl-right float-sm-right float-md-right float-xs-right fdselectbutton');


        this.options = this.fdSelectOptions;
        this.elementList = this.listaElementos;
        this.showList = true;
        this.filtroBusqueda = '';
        this.noData = false;
    }
    ngOnChanges(changes: SimpleChanges) {
        this.elementList = this.listaElementos;
    }

    // fromero
    // handler del modal de confirmación
    // 07/05/2019
    getConfirmationModalResponse(event) {
        if (event[0] == true) {
            this.guardarSeleccion();
        }
    }

    // fromero
    // método para emitir cuado se guarda la selección de elementos
    // 07/05/2019
    public guardarSeleccion() {
        this.showList = false;
        let seleccionados = [];

        this.listaElementos.forEach(element => {
            if (element.checked) {
                seleccionados.push(element.objeto);
            }
        });

        this.listaSeleccionados.emit({ elementosSeleccionados: seleccionados });
        this.modalDeleteMessage.disabled = true;
        this.filtroBusqueda = '';
    }


    // fromero
    // métodos para mostrar o no lista desplegable

    public showListP(event?) {


        if (event !== undefined && (!event.value || event.value === '')) {
            this.filtroBusqueda = '';

        }

        if (this.filtroBusqueda === '') {
            $('#fdListaSelect').css({ 'visibility': 'hidden' });
            this.showList = false;
        } else {
            $('#fdListaSelect').css({ 'visibility': 'visible' });
            this.showList = true;
        }
        this.buscar();
    }

    // fromero
    // método de emición de evento para el padre
    // 07/05/2019
    public buscar() {
        this.buscarInformacion.emit({ filtro: this.filtroBusqueda });
    }


    // fromero
    // método para validar boton de guardado
    // 07/05/2019
    public validarCheckeds() {
        var count = 0;
        this.listaElementos.forEach(element => {
            if (element.checked) {
                count = count + 1;
            }
        });
        if (count > 0) {
            this.modalDeleteMessage.disabled = false;
        } else {
            this.modalDeleteMessage.disabled = true;
        }
    }

    // fromero
    // métodos accesibilidad por teclado

    public checkElement(element: fdSelectModelList, estado?) {
        element.checked = !element.checked;
        this.validarCheckeds();
    }
    // fromero
    // métodos accesibilidad por teclado
    public moveDown() {

        const activeElement = document.activeElement;
        const nextSibling: any = document.activeElement.nextSibling;
        let id = nextSibling.id;

        if (activeElement.id === 'fd-search-input') {
            id = document.activeElement.nextElementSibling.firstElementChild.firstElementChild.id;
            document.getElementById(id).focus();
        } else {
            if (id !== 'btnAccionSelect') {
                document.getElementById(id).focus();
            } else {
                document.getElementById('btnfiltro').focus();
            }
        }

    }

    // fromero
    // métodos accesibilidad por teclado

    public moveUp() {
        const previousSibling: any = document.activeElement.previousSibling;
        let id;
        if (previousSibling != null && previousSibling.id !== undefined) {
            id = previousSibling.id;
        } else {
            if (document.activeElement.id === 'btnfiltro') {
                const longitudlista = document.activeElement.parentNode.parentNode.children.length;
                id = document.activeElement.parentNode.parentNode.children[longitudlista - 2].id;
            } else {
                id = 'fd-search-input';
            }
        }
        document.getElementById(id).focus();
    }
}
